
import { customRiseCompletions } from "../../../../../routes/ai-bot/admin/tabs/general/configurations-tab/fusionbot-tab/fusion-rise-config/fusion-rise-config.component";
import { EventsStringService } from "../../../../services/events-string.service";
import { BlocklyHelperService } from "../blockly-helper.service";
import { BLOCKLY_COLORS, BLOCKLY_DUMMY, BlocklyToolboxCategory } from "../blocky-types.types";
export type customCode = {
  code: string,
  info: string
}


let LXT = {
  currentPageObj: null,
  currentPageNumber: 0,
  currentPageContent: null,
  isLastPage: false,
  isFirstPage: false,
  pageId: null,
  pageHistory: [],
  pageCount: 0
}

export function BlocklyCategory_VIEW_FUSION_LXT(name: string = "unnamed", BH: BlocklyHelperService, eventStringService: EventsStringService): BlocklyToolboxCategory {
  const lxtActions: customCode[] = [
    { code: 'LXT.currentPageObj', info: 'Rückgabe des gesamten aktuellen Seitenobjekts' },
    { code: 'LXT.currentPageNumber', info: 'Die aktuelle Seitennummer' },
    { code: 'LXT.currentPageContent', info: 'Inhalt der aktuellen Seite' },
    { code: 'LXT.isFirstPage', info: 'Boolean ob es die erste Seite ist' },
    { code: 'LXT.isLastPage', info: 'Boolean ob es die letzte Seite ist' },
    { code: 'LXT.pageCount', info: 'Anzahl der Seiten' },
    { code: 'LXT.pageHistory', info: 'Array der bisherigen Seitenhistorie' },
    { code: 'LXT.pageId', info: 'Die interne ID der aktuellen Seite' },
    { code: 'LXT.ALL_PAGES_AS_TEXT', info: 'Alle Überschriften - Beschreibungen - Seiteninhalte als Text' },
    { code: 'LXT.ALL_PAGES', info: 'Alle Überschriften - Beschreibungen - Seiteninhalte als Objekt' },
    { code: 'LXT.lastAnswerCorrect', info: 'Boolean ob die letzte Antwort korrekt ist' },
    { code: 'LXT.lastAnsweredQuestion', info: 'Rückgabe der letzten beantworteten Frage' }
  ];




  /*

  */
  /*
   */

  const cat: BlocklyToolboxCategory = {
    kind: 'category', colour: BLOCKLY_COLORS.FUSION, name: name, contents: [
      BH.label("Bot-Ansichten -> " + name),
      BH.propertyDropdown("LXT_PROPERTIES", "LXT:",
        lxtActions.map((crc) => {
          return [crc.info, "await RAGAI.PARENT.get('" + crc.code + "')"];
        })
      ),

      BH.actionDropdown("LXT_ACTIONS", "LXT: Seite", [
        ["weiter", "RAGAI.PARENT.exec('LXT.nextPage()');"],
        ["zurück", "RAGAI.PARENT.exec('LXT.prevPage()');"]
      ]),


      BH.withNested(
        BH.action("LXT_GO_TO_PAGE", "LXT: Gehe zu Seite Nummer{{page[@check=Number]}}", "RAGAI.PARENT.exec('LXT.goToPage({{page}})');"),
        [
          { forValue: 'page', isShadow: true, targetBlockType: BLOCKLY_DUMMY.NUMBER }
        ]),



      BH.eventDropdown("LXT_EVENTS", eventStringService.get("RAGAI.LXT.")),
      BH.eventDropdown("LXT_EVENTS_RAW", eventStringService.getRaw("RAGAI.LXT."))

    ]
  };
  return cat;
}
